export default __webpack_public_path__ + "static/media/card2.a2e42358.svg";